/**************************************************
 * Nombre:       Tarjeta_Indicador
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {theme} from "../../../Tema";
import icon from '../../RecursosGraficas/icon_default.svg'

const Tarjeta_Indicador = ({color = theme.palette.primary.main, icono = icon, titulo, valor}) => {

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                backgroundColor: color + 20,
                borderRadius: 2,
                p: 3,
                height: '100%',
                maxHeight: {xs: 210, sm: 500}
            }}
        >

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', marginTop: 1}}>
                <img src={icono} height={60} width={'auto'}/>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', marginTop: 3}}>
                <Typography
                    sx={{color: color, fontSize: 14, fontWeight: 700, textAlign: 'center'}}>{titulo}</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                <Typography sx={{color: color, fontSize: 18, fontWeight: 700, textAlign: 'center'}}>{valor}</Typography>
            </Grid>

        </Grid>
    )

}
export default Tarjeta_Indicador